import { render, staticRenderFns } from "./FichaPaciente.vue?vue&type=template&id=22bc4971&"
import script from "./FichaPaciente.vue?vue&type=script&lang=js&"
export * from "./FichaPaciente.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports